import { supabase } from '../lib/supabase'
import { banco, TABELAS_SYNC, type TabelaSync } from '../db/banco'

const TAMANHO_PAGINA = 1000
const CURSOR_INICIAL = '1970-01-01T00:00:00Z'

// Puxa deltas de uma tabela desde o ultimo cursor. Retorna o total de linhas.
// Limitacao aceita no v1 (registrada na spec): linhas com atualizado_em identico
// exatamente na borda da pagina podem exigir uma proxima sincronizacao.
export async function puxarTabela(tabela: TabelaSync): Promise<number> {
  const cursorSalvo = (await banco.cursores_sync.get(tabela))?.cursor ?? CURSOR_INICIAL
  let cursor = cursorSalvo
  let total = 0
  for (;;) {
    const { data, error } = await supabase
      .from(tabela)
      .select('*')
      .gt('atualizado_em', cursor)
      .order('atualizado_em', { ascending: true })
      .limit(TAMANHO_PAGINA)
    if (error) throw new Error(`Falha ao puxar ${tabela}: ${error.message}`)
    if (!data || data.length === 0) break
    await banco.table(tabela).bulkPut(data)
    cursor = (data[data.length - 1] as { atualizado_em: string }).atualizado_em
    total += data.length
    if (data.length < TAMANHO_PAGINA) break
  }
  if (cursor !== cursorSalvo) {
    await banco.cursores_sync.put({ tabela, cursor })
  }
  return total
}

export async function puxarTudo(): Promise<number> {
  let total = 0
  for (const tabela of TABELAS_SYNC) {
    total += await puxarTabela(tabela)
  }
  return total
}
